// store/modules/athlete.js
import {secureStorage} from "@/services/secureStorage";

export default {
    namespaced: true,
    state: () => ({
        roundIdToUpdate: JSON.parse(secureStorage.getItem('roundIdToUpdate')) || null,
        roundIdToView: JSON.parse(secureStorage.getItem('roundIdToView')) || null,
    }),
    mutations: {
        setRoundIdToUpdate(state, id) {
            state.roundIdToUpdate = id;
            secureStorage.setItem('roundIdToUpdate', id); // Almacena el roundIdToUpdate en secureStorage
        },
        resetRoundIdToUpdate(state) {
            state.roundIdToUpdate = null;
            secureStorage.removeItem('roundIdToUpdate'); // Elimina el roundIdToUpdate de secureStorage
        },
        setRoundIdToView(state, id) {
            state.roundIdToView = id;
            secureStorage.setItem('roundIdToView', id); // Almacena el roundIdToUpdate en secureStorage
        },
        resetRoundIdToView(state) {
            state.roundIdToView = null;
            secureStorage.removeItem('roundIdToView'); // Elimina el roundIdToUpdate de secureStorage
        },
    },
    actions: {

    },
    getters: {

    }
};
